import React, { useState } from 'react'
import '../customer/customer.css'
import { useCustomerDeletedRecordsQuery, useCustomerDetailsRestoreMutation, useMasterDetailsQuery } from '../../slices/Profile';
import { PopUp } from '../popup';
import { logDOM } from '@testing-library/react';
const CustomerRestore = () => {
    const { data: customerDeletedRecords, refetch: customerDeletedRecordsRefetch } = useCustomerDeletedRecordsQuery()
    const { data: masterData, refetch: masterDataRefetch } = useMasterDetailsQuery();

    const [customerDetailsRestore] = useCustomerDetailsRestoreMutation()
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const handleHideCustomer = async (customer) => {
        const payload = {
            customer_id: customer?.customer_id
        }
        let res = await customerDetailsRestore(payload)
        if (res?.data?.success) {
            setPopupMessage(res?.data?.message);
            setIsSuccess(true);
            setShowPopup(true);
        } else {
            setPopupMessage('Restore Failed');
            setIsSuccess(true);
            setShowPopup(true);
        }
        customerDeletedRecordsRefetch()
        masterDataRefetch()
    }
    return (
        <div>
            <div className='customer_heading'>
                <h3>Customer Hide Data</h3>
            </div>
            <div className="customer_card">
                {customerDeletedRecords && customerDeletedRecords?.data?.map((value, index) => (
                    <div key={index} className="customer_card_data">
                        <div className='edit_button'>
                            <button onClick={() => handleHideCustomer(value)}>Restore</button>
                        </div>

                        <div>
                            <span className='customer_title'>Name: </span><span className='address_details'>{value?.cust_name}</span>
                        </div>
                        <div>
                            <span className='customer_title'>Address: </span><span className='address_details'>{value?.cust_address}</span>
                        </div>
                        <div>
                            <span className='customer_title'>Gstin: </span><span className='address_details'>{value?.gst_no}</span>
                        </div>
                    </div>
                ))}
            </div>

            {showPopup && (
                <PopUp
                    message={popupMessage}
                    isSuccess={isSuccess}
                    onClose={() => setShowPopup(false)}
                />
            )}
        </div>
    );
};

export default CustomerRestore